/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from "react-router-dom";
import AddDepartmentForm from "./AddDepartmentForm";
import { BsFileMedical, BsFillPersonFill } from "react-icons/bs";
import { AiOutlineComment } from "react-icons/ai";
import { GrLocation } from "react-icons/gr";
import "./admin-table.css";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchAllDepartments } from "../../redux/apiCalls/departmentApiCalls";
import { getUsersCount } from "../../redux/apiCalls/profileApiCalls";
import { getDoctorsCount } from "../../redux/apiCalls/doctorsApiCalls";
import { fetchAllComments } from "../../redux/apiCalls/commentApiCalls";
import AddCityForm from "./AddCityForm";
import { fetchAllCities } from "../../redux/apiCalls/cityApiCalls";

const AdminMain = () => {
  const dispatch = useDispatch();
  const departments = useSelector((state) => state.department.departments);
  const usersCount = useSelector((state) => state.profile.usersCount);
  const doctorsCount = useSelector((state) => state.doctor.doctorsCount);
  const comments = useSelector((state) => state.comment.comments);
  const cities = useSelector((state) => state.city.cities);

  useEffect(() => {
    dispatch(fetchAllDepartments());
    dispatch(fetchAllCities());
    dispatch(getUsersCount());
    dispatch(getDoctorsCount());
    dispatch(fetchAllComments());
  }, []);

  return (
    <div className="admin-main">
      <div className="admin-main-header">
        <div className="admin-main-card">
          <h5 className="admin-card-title">المستخدمون</h5>
          <div className="admin-card-count">{usersCount}</div>
          <div className="admin-card-link-wrapper">
            <Link to="/admin-dashboard/users-table" className="admin-card-link">
              جميع المستخدمين
            </Link>
            <div>
              <BsFillPersonFill className="admin-card-icon" />
            </div>
          </div>
        </div>
        <div className="admin-main-card">
          <h5 className="admin-card-title">الأطباء</h5>
          <div className="admin-card-count"> {doctorsCount} </div>
          <div className="admin-card-link-wrapper">
            <Link
              to="/admin-dashboard/doctors-table"
              className="admin-card-link"
            >
              جميع الاطباء
            </Link>
            <div>
              <BsFillPersonFill className="admin-card-icon" />
            </div>
          </div>
        </div>
        <div className="admin-main-card">
          <h5 className="admin-card-title">التخصصات</h5>
          <div className="admin-card-count">{departments?.length}</div>
          <div className="admin-card-link-wrapper">
            <Link
              to="/admin-dashboard/categories-table"
              className="admin-card-link"
            >
              جميع التخصصات
            </Link>
            <div>
              <BsFileMedical className="admin-card-icon" />
            </div>
          </div>
        </div>
        <div className="admin-main-card">
          <h5 className="admin-card-title">المدن</h5>
          <div className="admin-card-count">{cities?.length}</div>
          <div className="admin-card-link-wrapper">
            <Link
              to="/admin-dashboard/cities-table"
              className="admin-card-link"
            >
              جميع المدن
            </Link>
            <div>
              <GrLocation className="admin-card-icon" />
            </div>
          </div>
        </div>
        <div className="admin-main-card">
          <h5 className="admin-card-title">التعليقات</h5>
          <div className="admin-card-count">{comments?.length}</div>
          <div className="admin-card-link-wrapper">
            <Link
              to="/admin-dashboard/comments-table"
              className="admin-card-link"
            >
              جميع التعليقات
            </Link>
            <div>
              <AiOutlineComment className="admin-card-icon" />
            </div>
          </div>
        </div>
      </div>
      <AddDepartmentForm />
      <AddCityForm />
    </div>
  );
};

export default AdminMain;
